<template>
    <div ref="intersectionTrigger" v-bind="$attrs"></div>
<!--    <spinner v-if="!fetch"></spinner>-->
</template>

<script>
    import {ref, watch} from "vue";
    import {makeUseInfiniteScroll} from "vue-use-infinite-scroll";

    export default {
        name: "infinityScroll",
        setup(props, {emit}) {
            const useInfiniteScroll = makeUseInfiniteScroll({}); // the argument is optional
            const intersectionTrigger = ref(null); // as Ref<HTMLElement>
            let fetch = ref(true);
            let delay = ref(250);
            const pageRef = useInfiniteScroll(intersectionTrigger);
            let page = 1;

            const fetchFirstPage = function () {
                page = 1;
                emit('fetch', {page: page});
                page++;
                fetch.value = false;
                setTimeout(() => {
                    fetch.value = true
                }, 250)
            }
            watch(
                pageRef,
                (p) => {
                    if (fetch.value) {
                        console.log('fetch',fetch.value);
                        emit('fetch', {page: page});
                        page++;
                        fetch.value = false;
                        // setTimeout(() => {
                        //     fetch.value = true
                        // }, 250)
                    }
                },
                {immediate: true}
            )

            return {intersectionTrigger, fetch, page ,fetchFirstPage};
        }
    }
</script>

<style scoped>

</style>
